import {
  PAGE_INCREMENT,
  PAGE_DECREMENT,
  PAGE_CLICKED_NEXT_UPDATE,
  CONTROL_LOADING,
  CONTROL_EDIT_BENEFIT,
  UPDATE_UI_DATA,
  SELECT_DOCUMENT,
  RESET_SELECT_DOCUMENT,
  ADD_FILE_TO_LIST,
  REMOVE_FILE_FROM_LIST,
  CHECKBOX_STATUS_UPDATE,
  CONTROL_DECLARATION,
  UPDATE_FORM_IS_VALID,
  EDIT_ALL_INVALID_FORM,
  EDIT_UPLOAD,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialUiData = {
  claimFormTitle: "Liability",
  pageNumber: 1,
  maxPageNumber: 1,
  showLoading: false,
  showDeclaration: false,
  occupationList: [],
  bankList: [],

  // ===== UPLOAD START =====
  proofDocuments: [],
  folderName: null,
  totalFileSize: 0,
  compressedFilesize: 0,
  lockUploadDropdown: false,
  isEditUpload: false,
  hideHeaderFooter: false,
  claimUploadListModel: [],
  tempSelectedDocument: {
    documentId: 0,
    documentDesc: "Please select your document name",
  },
  // ===== UPLOAD END =====

  checkBoxStatus: {
    isAgree: false,
  },
  submittedClaimID: "",
  editBenefits: {
    "Loss Details": false,
    "Claims Payout Instruction": false,
  },
  clickedNext: {
    // Number below is pageNumber
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  },
  formIsValid: {},
  witnessFieldIsEmpty: false,
}

const uiDataReducer = (state = initialUiData, action) => {
  const newState = Object.assign({}, state)

  switch (action.type) {
    case PAGE_INCREMENT:
      switch (newState.pageNumber) {
        case 2:
          if (newState.isEditUpload) {
            newState.isEditUpload = false
            newState.pageNumber = 5
          } else {
            newState.pageNumber += 1
          }
          break
        default:
          newState.pageNumber += 1
      }
      window.scroll(0, 0)
      if (newState.maxPageNumber < newState.pageNumber) {
        newState.maxPageNumber = newState.pageNumber
      }
      return newState

    case PAGE_DECREMENT:
      switch (newState.pageNumber) {
        case 2:
          newState.claimUploadListModel = []
          newState.pageNumber -= 1
          break
        case 5:
          newState.editBenefits = {}
          newState.pageNumber -= 1
          break

        default:
          newState.pageNumber -= 1
      }
      window.scroll(0, 0)
      return newState

    case PAGE_CLICKED_NEXT_UPDATE:
      newState.clickedNext[action.currentPageNumber] = action.changes
      return newState

    case CONTROL_LOADING:
      newState.showLoading
        ? (newState.showLoading = false)
        : (newState.showLoading = true)
      return newState

    case UPDATE_UI_DATA:
      newState[action.property] = action.newData
      return newState

    case SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: action.documentId,
        documentDesc: action.documentDesc,
      }
      return newState

    case RESET_SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: 0,
        documentDesc: "Please select your document name",
      }
      return newState

    case ADD_FILE_TO_LIST:
      newState.claimUploadListModel.push({
        fileName: action.fileName,
        documentId: action.documentId,
        filePath: action.filePath,
        fileSize: action.fileSize,
        folderName: action.folderName,
        compressedFilesize: action.compressedFilesize,
      })

      newState.totalFileSize += action.compressedFilesize

      return newState

    case REMOVE_FILE_FROM_LIST:
      let indexOfUploadedDocumentArray = newState.claimUploadListModel
        .map(function(e) {
          return e.fileName
        })
        .indexOf(action.fileName)
      newState.claimUploadListModel.splice(indexOfUploadedDocumentArray, 1)
      newState.totalFileSize -= action.fileSize
      return newState

    case CONTROL_EDIT_BENEFIT:
      newState.editBenefits[action.formName]
        ? (newState.editBenefits[action.formName] = false)
        : (newState.editBenefits[action.formName] = true)
      return newState

    case CHECKBOX_STATUS_UPDATE:
      !newState.checkBoxStatus[action.checkboxName]
        ? (newState.checkBoxStatus[action.checkboxName] = true)
        : (newState.checkBoxStatus[action.checkboxName] = false)
      return newState

    case CONTROL_DECLARATION:
      newState.showDeclaration
        ? (newState.showDeclaration = false)
        : (newState.showDeclaration = true)
      return newState

    case UPDATE_FORM_IS_VALID:
      newState.formIsValid[action.formName] = action.status
      return newState

    case EDIT_ALL_INVALID_FORM:
      newState.editBenefits = {}

      action.formlist.forEach((formlistItem, formlistKey) => {
        newState.editBenefits[formlistItem] = true
      })
      return newState

    case EDIT_UPLOAD:
      newState.isEditUpload = true
      newState.pageNumber = 2
      return newState

    default:
      return newState
  }
}

export default uiDataReducer
